// Copyright 2025 Sorama B.V.
import { GenericMeasurement, SpectrumSetAnalysisProperties } from "datatypes/SoramaWebApi";
import { IMeasurementProcessorResolver } from "services/Measurement/IMeasurementProcessorResolver";
import { ISpectralProcessingService } from "services/SoundProcessing/ISpectralProcessingService";
import { Frequency } from "units/Frequency";
import { Pressure } from "units/Pressure";
import { Time } from "units/Time";
import { ISpectrogramProvider, UnitSpectrogram } from "./ISpectrogramProvider";

export class SpectrogramProvider implements ISpectrogramProvider {
    constructor(private readonly processorResolver: IMeasurementProcessorResolver) {}

    public async getSpectrumSet(
        measurement: GenericMeasurement,
        properties: SpectrumSetAnalysisProperties,
        progressCallback: (progress: number) => void
    ): Promise<UnitSpectrogram> {
        const processor = await this.processorResolver.resolveProcessor<ISpectralProcessingService>(
            ISpectralProcessingService,
            measurement
        );

        const frequencySpectrumSet = await processor.getSpectrumSet(measurement, properties, progressCallback);

        const unitSpectrogram: UnitSpectrogram = {
            xAxisUnit: Time.second,
            yAxisUnit: Frequency.hertz,
            yAxisValues: frequencySpectrumSet.frequencies,
            dataUnit: Pressure.pascal,
            spectrumSet: frequencySpectrumSet.results,
        };

        return unitSpectrogram;
    }
}
